import * as yup from 'yup';

export const createSignupSchema = (t: (key: string) => string) =>
  yup.object({
    displayName: yup
      .string()
      .required(t('register.displayNameRequired'))
      .min(3, t('register.displayNameInvalid'))
      .max(50, t('register.displayNameTooLong')),
    email: yup
      .string()
      .required(t('register.emailRequired'))
      .email(t('register.invalidEmail')),
    password: yup
      .string()
      .required(t('register.passwordRequired'))
      .min(8, t('register.invalidPassword'))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
        t('register.passwordRequirements')
      ),
    confirmPassword: yup
      .string()
      .required(t('register.confirmPasswordRequired'))
      .oneOf([yup.ref('password')], t('register.passwordsMustMatch'))
      .min(8, t('register.invalidPassword'))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
        t('register.passwordRequirements')
      ),
  });
